var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "40", height: "39", viewBox: "0 0 40 39", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.667 25.507l7.643-7.31a3.412 3.412 0 0 1 2.357-.934c.883 0 1.731.335 2.356.933l7.644 7.311m-3.334-3.188l2.644-2.528a3.411 3.411 0 0 1 2.356-.934c.884 0 1.732.336 2.357.934l2.643 2.528m-10-9.565h.017M10 31.884h20c.884 0 1.732-.336 2.357-.934a3.12 3.12 0 0 0 .976-2.254V9.566a3.12 3.12 0 0 0-.976-2.255A3.412 3.412 0 0 0 30 6.377H10c-.884 0-1.732.336-2.357.934a3.12 3.12 0 0 0-.976 2.254v19.13c0 .846.35 1.657.976 2.255a3.412 3.412 0 0 0 2.357.934z", stroke: "#DADADA", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});